(function () {
  window.addEventListener('load', function () {
    AOS.refresh();
  });
})();

// Force external links to open in new tab / window
(function ($) {
  $(forceOpenLinksInNewTab);

  $(document).ajaxComplete(forceOpenLinksInNewTab);

  function forceOpenLinksInNewTab() {
    var siteName = window.location.host.replace('www.', '');
    $(
      'a[href^="htt"]' +
        ':not([target])' +
        ':not([href*="www.' + siteName + '"])' + 
        ':not([href*="//' + siteName +'"])' + 
        ':not([class*="fancybox"])' + 
        ',' + 
        'a[href$=".pdf"]'
    ).attr('target', '_blank');
  }

  $(function() {
    // Hide global links from login page
    var pathUrl = window.location.pathname;
    pathUrl = pathUrl.substr(pathUrl.indexOf('/') + 1);
    if (pathUrl == 'user/login') {
      $('#block-trs-local-tasks ul').hide();
    }
  });
})(jQuery);

jQuery(window).on({
  'orientationchange resize scroll load': function (e) {
    detect_touchDevice();
  },
});

function detect_touchDevice() {
  var is_touch_device = 'ontouchstart' in document.documentElement;
  if (is_touch_device) {
    jQuery('body').addClass('touch');
  }
  // Add class on touch device//

  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    jQuery('body').addClass('touch');
  } else {
    jQuery('body').removeClass('touch');
  }
}
